<template>
  <div>
    <data-table
      :data="dataObjectStr">
      </data-table>
  </div>
</template>

<script>
import DataTable from '@wc/data-table/data-table.vue';

export default {
  props: {
    tableDataId: { type: String }
  },
  data () {
    return {
      dataObj: {},
      dataObjectStr: '{"data":[],"colums":[]}',
      chartOptionsObjStr: ''
    };
  },
  components: {
    DataTable
  },
  mounted () {
    this.getTableData();
  },
  methods: {
    getTableData: function () {
      let dataObj = {
        columns: [],
        data: [],
        allowSearch: false
      };
      if (this.tableDataId === '1') {
        dataObj = {
          columns: [
            {
              name: 'Country',
              type: 'string'
            },
            {
              name: 'Survey year',
              type: 'string'
            }
          ],
          data: [
            ['Armenia', '2022'],
            ['Bangladesh', '2016'],
            ['Bhutan', '2022'],
            ['Cambodia', '2019-2020'],
            ['Cook Islands', '2015-2016'],
            ['Fiji', '2019'],
            ['Georgia', '2022'],
            ['India', '2011-2012'],
            ['Indonesia', '2023'],
            ['Kiribati', '2019-2020'],
            ['Kyrgyzstan', '2018'],
            ['Lao PDR', '2018-2019'],
            ['Maldives', '2019'],
            ['Marshall Islands', '2019-2020'],
            ['Micronesia', '2013-2014'],
            ['Mongolia', '2022'],
            ['Myanmar', '2014-2015'],
            ['Nepal', '2022-2023'],
            ['Pakistan', '2015-2016'],
            ['Palau', '2020'],
            ['Philippines', '2019'],
            ['Samoa', '2018'],
            ['Sri Lanka', '2016'],
            ['Thailand', '2023'],
            ['Tonga', '2021'],
            ['Türkiye', '2019'],
            ['Uzbekistan', '2018'],
            ['Vanuatu', '2019'],
            ['Viet Nam', '2016']
          ],
          allowSearch: true
        };
      } else if (this.tableDataId === '2') {
        dataObj = {
          columns: [
            {
              name: 'Country',
              type: 'string'
            },
            {
              name: 'Child Benefit',
              type: 'string'
            },
            {
              name: 'Disability Benefit',
              type: 'string'
            },
            {
              name: 'Maternity Benefit',
              type: 'string'
            },
            {
              name: 'Old age Benefit',
              type: 'string'
            }
          ],
          data: [
            ['Armenia', 'Birth or adoption grant,  childcare leave allowance', 'Disability social pension', 'Maternity allowance', 'Old age social pension'],
            ['Bangladesh', '', 'Disability social pension,  allowance for financially insolvent persons with disabilities', '', 'Old age allowance programme'],
            ['Cambodia', '', 'Disability allowance', 'Maternity grant', ''],
            ['Cook Islands', 'Child benefit', 'Infirm benefit,  destitute benefit', 'New-born allowance', 'Old age pension'],
            ['Georgia', 'Child allowance', 'Social package for persons with disabilities', 'Maternity benefit', 'Old age pension'],
            ['Fiji', '', '', '', ''],
            ['India', '', 'Indira Gandhi National Disability Pension Scheme (IGNDPS)', 'Janani Suraksha Yojana,  JSY (former National Maternity Benefit Scheme (NMBS)),  Pradhan Mantri Matritva Vandana Yojana (PMMVY)', 'Indira Gandhi National Old Age Pension Scheme'],
            ['Indonesia', 'PKH,  Program Kesejahteraan Sosial Anak (PKSA)', 'Program Keluarga Harapan', 'Program Keluarga Harapan (PKH)', 'Program Keluarga Harapan'],
            ['Kiribati', '', '', '', 'Elderly fund'],
            ['Kyrgyzstan', 'Childcare allowance,  family allowance', 'Disability social pension', 'Maternity allowance,  birth grant', 'Social assistance allowance (old age)'],
            ['Maldives', 'Single parent allowance,  foster parent allowance', 'Disability assistance scheme', '', 'Old age basic pension'],
            ['Mongolia', 'Child money programme', 'Social Welfare Pensions and Allowance for the Elderly and the Disabled', 'Allowance for mothers and children', 'Social Welfare Pensions and Allowance for the Elderly and the Disabled'],
            ['Myanmar', '', '', '', ''],
            ['Nepal', 'Child grant', 'Full and partial disability allowance', 'Safe motherhood/Post-natal care allowance', 'Senior citizen allowance'],
            ['Pakistan', '', 'Pakistan Bait-ul-Mal', 'Ehsaas’ Nashonuma', ''],
            ['Palau', '', 'Disability Pension', '', ''],
            ['Philippines', '', '', '', 'Social pension'],
            ['Samoa', '', '', '', ''],
            ['Sri Lanka', '', 'Public Welfare Assistance Allowance “pin padi” program,  National Secretariat for Persons with Disability Programmes', '', 'Public Welfare Assistance Allowance “pin padi” program,  Financial Support to Elderly or Elderly Assistance Programme'],
            ['Thailand', 'Child support grant', 'Allowances for people living with disabilities', '', 'Universal pension scheme'],
            ['Tonga', '', 'A’uki ai cash assistance (Disability Welfare Scheme)', '', 'Social welfare scheme'],
            ['Turkey', '', '', '', 'Means-tested old age pension'],
            ['Uzbekistan', 'Family allowance', 'Disability social pension', '', 'Old age social pension'],
            ['Vanuatu', 'Child benefits', 'Disability social pension', '', 'Old age social pension'],
            ['Vietnam', 'Child benefit', 'Disability benefit', '', 'Social pension scheme']
          ],
          allowSearch: true
        };
      } else if (this.tableDataId === '3') {
        dataObj = {
          columns: [
            {
              name: 'Country',
              type: 'string'
            },
            {
              name: 'Dataset includes questions on disability',
              type: 'string'
            },
            {
              name: 'National prevalence (%)',
              type: 'string'
            },
            {
              name: 'Children Age',
              type: 'string'
            },
            {
              name: 'Children %',
              type: 'string'
            },
            {
              name: 'Adult Age',
              type: 'string'
            },
            {
              name: 'Adult %',
              type: 'string'
            },
            {
              name: 'Older persons Age',
              type: 'string'
            },
            {
              name: 'Older persons %',
              type: 'string'
            },
            {
              name: 'Total',
              type: 'string'
            }
          ],
          data: [
            ['Armenia', 'Yes', 5.1, '0-17 years', 3.9, '18-59 years', 46, '60+ years', 50, 100],
            ['Bangladesh', 'Yes', 6.7, '0-15 years', 24.4, '16-59 years', 43.1, '60+ years', 32.5, 100],
            ['Bhutan', 'No', 3.26, '0-17 years', 30.3, '18-59 years', 58.4, '60+ years', 11.3, 100],
            ['Cambodia', 'Yes', 62, '0-17 years', 0, '18-59 years', 37.2, '60+ years', 62.8, 100],
            ['Cook Islands', 'No', 1.7, '0-14 years', 6.8, '15-59 years', 76.2, '60+ years', 17, 100],
            ['Georgia', 'No', 3.2, '0-14 years', 5, '15-59 years', 60, '60+ years', 35, 100],
            ['India', 'Yes', 2.1, '0-15 years', 10.1, '16-59 years', 31.8, '60+ years', 58.1, 100],
            ['Indonesia', 'Yes', 1.76, '0-17 years', 6.6, '18-59 years', 31.43, '60+ years', 61.97, 100],
            ['Kiribati', 'Yes', 5.8, '0-17 years', 31.9, '18-59 years', 36.8, '60+ years', 31.3, 100],
            ['Kyrgyzstan', 'No', 2.5, '0-14 years', 5, '15-59 years', 60, '60+ years', 35, 100],
            ['Lao PDR', 'No', 0.91, '5-17 years', 36.12, '18-59 years', 55.79, '60+ years', 8.09, 100],
            ['Maldives', 'No', 10.9, '5-14 years', 12.1, '15-49 years', 40.5, '50+ years', 47.4, 100],
            ['Marshall Islands', 'Yes', 3.5, '5-17 years', 13.47, '18-59 years', 46.57, '60+ years', 39.96, 100],
            ['Micronesia', 'No', 11, '0-17 years', 40.6, '18-59 years', 52.72, '60+ years', 6.68, 100],
            ['Mongolia', 'Yes', 3.9, '0-17 years', 9.9, '18-59 years', 66.4, '60+ years', 23.7, 100],
            ['Myanmar', 'No', 13, '5-17 years', 34.5, '18-59 years', 54.84, '60+ years', 10.65, 100],
            ['Nepal', 'Yes', 1.41, '0-17 years', 11.63, '18-59 years', 44.16, '60+ years', 44.2, 100],
            ['Pakistan', 'No', 2.5, '0-14 years', 5, '15-59 years', 60, '60+ years', 35, 100],
            ['Palau', 'Yes', 3.66, '0-17 years', 13.21, '18-59 years', 29.78, '60+ years', 57.02, 100],
            ['Samoa', 'Yes', 1.39, '0-14 years', 6.92, '15-59 years', 33.22, '60+ years', 59.86, 100],
            ['Philippines', 'No', 1.6, '0-14 years', 18.9, '15-59 years', 52.9, '60+ years', 28.2, 100],
            ['Sri Lanka', 'Yes', 8.7, '0-14 years', 3.6, '15-59 years', 43.2, '60+ years', 53.2, 100],
            ['Thailand', 'Yes', 3.76, '0-14 years', 6.09, '15-59 years', 38.08, '60+ years', 55.82, 100],
            ['Tonga', 'No', 3.66, '0-17 years', 13.21, '18-59 years', 29.78, '60+ years', 57.02, 100],
            ['Türkiye', 'Yes', 3.8, '0-17 years', 14, '18-59 years', 41.2, '60+ years', 44.8, 100],
            ['Uzbekistan', 'Yes', 3.5, '0-17 years', 33.42, '18-59 years', 58.42, '60+ years', 8.16, 100],
            ['Vanuatu', 'Yes', 3.66, '0-17 years', 13.21, '18-59 years', 29.78, '60+ years', 57.02, 100],
            ['Vietnam', 'No', 7.8, '5-15 years', 3.8, '16-59 years', 41.8, '60+ years', 54.6, 100]
          ],
          allowSearch: true
        };
      } else if (this.tableDataId === '4') {
        dataObj = {
          columns: [
            {
              name: 'Acronym',
              type: 'string'
            },
            {
              name: 'Name',
              type: 'string'
            }
          ],
          data: [
            ['4Ps', 'Pantawid Pamilyang Pilipino Program'],
            ['AHS', 'Annual Household Survey'],
            ['APIS', 'Annual Poverty Indicator Survey, Philippines'],
            ['BLSS', 'Bhutan Living Standard Survey'],
            ['BISP', 'Benazir Income Support Programme'],
            ['CSES', 'Cambodia Socio-Economic Survey'],
            ['EA', 'Economic Affairs'],
            ['FGT', 'Foster-Greer-Thorbecke'],
            ['GDP', 'Gross Domestic Product'],
            ['GEL', 'Georgian Lari'],
            ['GFS', 'Government Finance Statistics, IMF'],
            ['GPS', 'General Public Services'],
            ['HIES', 'Household Integrated Economic Survey, Pakistan'],
            ['HIICS', 'Household Integrated Income & Consumption survey'],
            ['HILCS', "Households' Integrated Living Conditions Survey"],
            ['HSES', 'Household Socio-Economic Survey, Mongolia'],
            ['IDR', 'Indonesian Rupiah'],
            ['IFF', 'Illicit Financial Flows'],
            ['IGNDPS', 'Indira Gandhi National Disability Pension Scheme'],
            ['IGNOAPS', 'Indira Gandhi National Old Age Pension Scheme'],
            ['IHDS', 'India Human Development Survey, India'],
            ['IMF', 'International Monetary Fund'],
            ['INR', 'Indian Rupee'],
            ['KIHS', 'Kyrgyz Integrated Household Survey'],
            ['MNT', 'Mongolian Tugrik'],
            ['OAP', 'Old Age Pension'],
            ['PHP', 'Philippine Piso'],
            ['PKH', 'Program Keluarga Harapan'],
            ['PKR', 'Pakistani Rupee'],
            ['PMT', 'Proxy Means test'],
            ['POS', 'Public order services'],
            ['PPP', 'Purchasing Power Parity'],
            ['SES', '(Household) Socio-Economic Survey'],
            ['SP', 'Social Protection'],
            ['SUSENAS', 'Survei Sosial Ekonomi Nasional, National Socio-Economic Survey'],
            ['TSA', 'Targeted Social Assistant, Georgia'],
            ['UNDESA', 'United Nations Department of Economic and Social Affairs'],
            ['USD', 'United States Dollar'],
            ['VHLSS', 'Vietnam Household Living Standards Survey'],
            ['VND', 'Vietnamese Dong'],
            ['WMS', 'Household Incomes and Expenditures Survey (HIES), Georgia']
          ],
          allowSearch: true
        };
      } else if (this.tableDataId === '5') {
        dataObj = {
          columns: [
            {
              name: 'Variables',
              type: 'string',
              orderable: false
            },
            {
              name: 'Number of children below 18 in Household',
              type: 'string',
              orderable: false
            },
            {
              name: 'Proportion of children',
              type: 'string',
              orderable: false
            },
            {
              name: 'Female HH',
              type: 'string',
              orderable: false
            },
            {
              name: 'Education level of HH',
              type: 'string',
              orderable: false
            },
            {
              name: 'Marital status of HH',
              type: 'string',
              orderable: false
            },
            {
              name: 'Type of sanitation facility',
              type: 'string',
              orderable: false
            },
            {
              name: 'Material of walls',
              type: 'string',
              orderable: false
            },
            {
              name: 'Material of floors',
              type: 'string',
              orderable: false
            },
            {
              name: 'Material of roof',
              type: 'string',
              orderable: false
            },
            {
              name: 'Asset index',
              type: 'string',
              orderable: false
            },
            {
              name: 'Children below 18 who engage in work',
              type: 'string',
              orderable: false
            },
            {
              name: 'Employment 1 (Indonesia)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Employment 2 (Indonesia)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Employment 3 (Indonesia)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Employment 4 (Indonesia)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Employment 5 (Indonesia)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Employment 6 (Indonesia)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Household size',
              type: 'string',
              orderable: false
            },
            {
              name: 'Age in single years of HH',
              type: 'string',
              orderable: false
            },
            {
              name: 'Age in single years of HH squared',
              type: 'string',
              orderable: false
            },
            {
              name: 'Indicator for urban/rural',
              type: 'string',
              orderable: false
            },
            {
              name: 'Shared toilet facilities',
              type: 'string',
              orderable: false
            },
            {
              name: 'Type of dwelling',
              type: 'string',
              orderable: false
            },
            {
              name: 'Number of rooms in the dwelling',
              type: 'string',
              orderable: false
            },
            {
              name: 'Getting wage from employment',
              type: 'string',
              orderable: false
            },
            {
              name: 'Self-employed',
              type: 'string',
              orderable: false
            },
            {
              name: 'Employment 1 (Bangladesh)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Employment 2 (Bangladesh)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Employment (Bangladesh, Vietnam and India)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Employment 3 (Bangladesh)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Working',
              type: 'string',
              orderable: false
            },
            {
              name: 'Orphans in the household',
              type: 'string',
              orderable: false
            },
            {
              name: 'Employment (India and Vietnam)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Employment (Kyrgyzstan)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Employment 1 (Nepal)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Employment 2 (Nepal)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Employment 3 (Nepal)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Employment 4 (Nepal)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Employment 5 (Nepal)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Dwelling Type 1 (Sri Lanka)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Dwelling Type 2 (Sri Lanka)',
              type: 'string',
              orderable: false
            },
            {
              name: 'Logarithm of dwelling size in square meters',
              type: 'string',
              orderable: false
            },
            {
              name: 'Assets purchased',
              type: 'string',
              orderable: false
            },
            {
              name: 'Constant',
              type: 'string',
              orderable: false
            },
            {
              name: 'Observations',
              type: 'string',
              orderable: false
            },
            {
              name: 'R-squared',
              type: 'string',
              orderable: false
            }
          ],
          data: [
            ['Armenia', '0.0490**', '-0.446***', '-0.0225', '0.0375***', '0.0157*', '', '', '', '', '', '0.0354', '', '', '', '', '', '', '-0.0576***', '-0.00406', '2.18E-05', '0.00113', '', '-0.0374***', '', '-0.183***', '-0.220***', '', '', '', '', '0.265***', '', '', '', '', '', '', '', '', '', '', '', '', '11.26***', '5,036', '0.187'],
            ['', '-0.0217', '-0.0988', '-0.0206', '-0.00408', '-0.00911', '', '', '', '', '', '-0.0564', '', '', '', '', '', '', '-0.00556', '-0.00293', '-2.47E-05', '-0.015', '', '-0.0121', '', '-0.057', '-0.0572', '', '', '', '', '-0.058', '', '', '', '', '', '', '', '', '', '', '', '', '-0.0923', '', ''],
            ['Bangladesh', '0.0648***', '-0.552***', '0.0790***', '', '-0.0447***', '-0.0453***', '0.0256***', '', '0.0783***', '0.115***', '0.0254', '', '', '', '', '', '', '-0.128***', '0.00836***', '-7.60e-05***', '-0.0348***', '', '', '0.0501***', '', '', '-0.0376', '0.0833***', '0.0908***', '0.103***', '', '', '', '', '', '', '', '', '', '', '', '', '', '8.209***', '45,580', '0.52'],
            ['', '-0.0082', '-0.0355', '-0.00968', '', '-0.00505', '-0.00195', '-0.00239', '', '-0.00536', '-0.002', '-0.0315', '', '', '', '', '', '', '-0.00381', '-0.00105', '-1.06E-05', '-0.00693', '', '', '-0.00456', '', '', '-0.0331', '-0.00787', '-0.00742', '-0.00828', '', '', '', '', '', '', '', '', '', '', '', '', '', '-0.033', '', ''],
            ['Bhutan', '0.186***', '-1.083***', '0.0298***', '0.0227***', '6.74E-05', '0.0362', '0.0016', '0.0122***', '0.00275', '0.105***', '', '', '', '', '', '', '', '-0.212***', '-0.0132***', '7.56e-05***', '0.0267**', '0.00119', '0.0119', '0.0523***', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '10.41***', '13,334', '0.538'],
            ['', '-0.0147', '-0.062', '-0.0108', '-0.00333', '-0.006', '-0.052', '-0.00108', '-0.00344', '-0.00187', '-0.00294', '', '', '', '', '', '', '', '-0.00558', '-0.00201', '-1.91E-05', '-0.0112', '-0.0185', '-0.00757', '-0.00315', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '-0.0802', '', ''],
            ['Cook Islands', '0.169***', '-0.922***', '0.0875*', '0.00578', '-0.0410*', '', '-0.0832**', '0.0313', '0.0675', '0.0826***', '0.168', '', '', '', '', '', '', '-0.193***', '0.00581', '-5.20E-05', '-0.0723', '', '0.157', '0.0326**', '0.237***', '0.878***', '', '', '', '', '0.0484', '', '', '', '', '', '', '', '', '', '', '', '', '7.044***', '684', '0.551'],
            ['', '-0.0644', '-0.255', '-0.0493', '-0.0372', '-0.0218', '', '-0.0324', '-0.0595', '-0.0793', '-0.0101', '-0.107', '', '', '', '', '', '', '-0.027', '-0.00709', '-6.41E-05', '-0.059', '', '-0.134', '-0.016', '-0.0748', '-0.146', '', '', '', '', '-0.0835', '', '', '', '', '', '', '', '', '', '', '', '', '-0.369', '', ''],
            ['Micronesia', '0.108***', '-0.933***', '0.027', '0.0529***', '0.0189', '0.044', '', '', '', '0.0995***', '', '', '', '', '', '', '', '-0.154***', '0.00283', '-2.85E-06', '0.0845**', '', '0.0477', '0.0962***', '-0.0495', '-0.0379', '', '', '', '', '0.148', '', '', '', '', '', '', '', '', '', '', '', '', '5.355***', '1,658', '0.545'],
            ['', '-0.0239', '-0.136', '-0.0419', '-0.0121', '-0.0156', '-0.0332', '', '', '', '-0.00674', '', '', '', '', '', '', '', '-0.0108', '-0.00713', '-6.50E-05', '-0.036', '', '-0.0401', '-0.0109', '-0.125', '-0.125', '', '', '', '', '-0.124', '', '', '', '', '', '', '', '', '', '', '', '', '-0.205', '', ''],
            ['Georgia', '0.174***', '-1.160***', '0.0388*', '0.0617***', '-0.0017', '-0.0320***', '', '', '', '0.147***', '0.220**', '', '', '', '', '', '', '-0.153***', '-0.0203***', '0.000164***', '0.0685***', '-0.00704', '-0.00182', '0.0428***', '0.308***', '0.220***', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '6.564***', '13,399', '0.358'],
            ['', '-0.0212', '-0.0956', '-0.0204', '-0.0103', '-0.00571', '-0.0073', '', '', '', '-0.00492', '-0.0916', '', '', '', '', '', '', '-0.00663', '-0.00314', '-2.62E-05', '-0.0202', '-0.0113', '-0.00298', '-0.00445', '-0.0174', '-0.0196', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '-0.114', '', ''],
            ['Indonesia', '0.0998***', '-0.844***', '-0.0367**', '0.0522***', '0.0591***', '-0.00734', '-0.0173***', '-0.0279***', '-0.00191', '0.173***', '0.171***', '0.018', '-0.0261', '0.137***', '0.0420**', '-0.0266', '-0.0104', '-0.160***', '0.00691***', '-0.000105***', '0.0498***', '-0.0370**', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '14.34***', '31,388', '0.499'],
            ['', '-0.015', '-0.0625', '-0.0181', '-0.00404', '-0.00935', '-0.00715', '-0.00379', '-0.00241', '-0.00656', '-0.00325', '-0.0331', '-0.0186', '-0.0185', '-0.0285', '-0.0186', '-0.021', '-0.0351', '-0.00555', '-0.00228', '-2.19E-05', '-0.00868', '-0.0153', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '-0.071', '', ''],
            ['India', '0.114***', '-0.807***', '0.0129', '0.0123***', '-0.0240***', '-0.0464***', '-0.0127', '-0.0992***', '-0.0402***', '0.0642***', '0.0564***', '', '', '', '', '', '', '-0.139***', '0.00655***', '-6.14e-05***', '0.166***', '', '', '0.0191***', '0.0855***', '', '', '', '-0.00559', '', '', '0.0583', '0.0189', '', '', '', '', '', '', '', '', '', '', '7.288***', '41,375', '0.477'],
            ['', '-0.00807', '-0.0409', '-0.0148', '-0.00116', '-0.00618', '-0.0085', '-0.00962', '-0.0105', '-0.00818', '-0.00121', '-0.0165', '', '', '', '', '', '', '-0.00323', '-0.00178', '-1.79E-05', '-0.00821', '', '', '-0.00281', '-0.0131', '', '', '', '-0.0118', '', '', '-0.0383', '-0.015', '', '', '', '', '', '', '', '', '', '', '-0.0522', '', ''],
            ['Kyrgyzstan', '0.0980***', '-0.680***', '-0.0537**', '-0.00861***', '-0.0179***', '', '', '', '', '', '', '', '', '', '', '', '', '-0.153***', '0.0144***', '-0.000133***', '0.0216', '', '', '', '', '', '', '', '', '', '', '', '', '0.0673***', '', '', '', '', '', '', '', '', '', '8.822***', '5,015', '0.423'],
            ['', '-0.0168', '-0.073', '-0.0224', '-0.00285', '-0.00621', '', '', '', '', '', '', '', '', '', '', '', '', '-0.00825', '-0.0033', '-2.86E-05', '-0.0197', '', '', '', '', '', '', '', '', '', '', '', '', '-0.0183', '', '', '', '', '', '', '', '', '', '-0.105', '', ''],
            ['Cambodia', '0.0784***', '-0.604***', '-0.0516***', '0.0322***', '0.0149*', '0.0149***', '-0.00748**', '0.0176***', '-0.00278', '0.128***', '', '', '', '', '', '', '', '-0.139***', '0.00783***', '-9.66e-05***', '0.0358***', '-0.0104', '', '0.0721***', '-0.0481***', '0.00688', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '13.27***', '10,067', '0.522'],
            ['', '-0.013', '-0.061', '-0.0176', '-0.00404', '-0.00872', '-0.00421', '-0.00352', '-0.00233', '-0.00376', '-0.00337', '', '', '', '', '', '', '', '-0.00509', '-0.00217', '-2.11E-05', '-0.0113', '-0.0149', '', '-0.00655', '-0.0171', '-0.0159', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '-0.0632', '', ''],
            ['Kiribati', '0.0736***', '-0.857***', '-0.0208', '', '0.00557', '-0.0185***', '', '', '', '', '0.0434', '', '', '', '', '', '', '-0.107***', '0.00515', '-8.10E-05', '-0.557***', '', '0.0157', '0.0878***', '0.146**', '0.0521', '', '', '', '', '-0.0187', '', '', '', '', '', '', '', '', '', '', '', '', '6.022***', '2,182', '0.392'],
            ['', '-0.0222', '-0.125', '-0.0276', '', '-0.0235', '-0.00268', '', '', '', '', '-0.0739', '', '', '', '', '', '', '-0.00941', '-0.00517', '-5.29E-05', '-0.0602', '', '-0.0237', '-0.0128', '-0.0704', '-0.0508', '', '', '', '', '-0.0694', '', '', '', '', '', '', '', '', '', '', '', '', '-0.133', '', ''],
            ['Lao PDR', '0.147***', '-0.786***', '0.0279', '0.0457***', '0.00853', '0.108***', '-0.0106**', '-0.0402***', '0.0262**', '0.122***', '0.0361*', '', '', '', '', '', '', '-0.181***', '0.000365', '6.63E-06', '-0.0616***', '', '', '', '0.0923***', '-0.0278', '', '', '', '', '0.0427**', '0.00652', '', '', '', '', '', '', '', '', '', '', '', '13.92***', '5,992', '0.518'],
            ['', '-0.016', '-0.0807', '-0.0302', '-0.00588', '-0.0116', '-0.0178', '-0.00505', '-0.00706', '-0.011', '-0.00616', '-0.021', '', '', '', '', '', '', '-0.00754', '-0.00307', '-2.97E-05', '-0.0176', '', '', '', '-0.0264', '-0.0197', '', '', '', '', '-0.018', '-0.0224', '', '', '', '', '', '', '', '', '', '', '', '-0.104', '', ''],
            ['Sri Lanka', '0.156***', '-0.746***', '0.00578', '0.0525***', '0.0051', '-0.00539', '0.0182', '0.0269', '0.0343***', '0.169***', '0.0433', '', '', '', '', '', '', '-0.201***', '-0.00356**', '-6.53E-06', '-0.104***', '', '', '0.0534***', '-0.121***', '-0.135***', '', '', '', '', '0.137***', '', '', '', '', '', '', '', '', '-0.0397**', '0.0985**', '', '', '10.14***', '21,756', '0.513'],
            ['', '-0.0113', '-0.0464', '-0.00991', '-0.00311', '-0.00788', '-0.00427', '-0.0125', '-0.0164', '-0.0131', '-0.00233', '-0.0375', '', '', '', '', '', '', '-0.00411', '-0.00166', '-1.52E-05', '-0.00996', '', '', '-0.00415', '-0.0239', '-0.0238', '', '', '', '', '-0.0241', '', '', '', '', '', '', '', '', '-0.0163', '-0.0446', '', '', '-0.0524', '', ''],
            ['Maldives', '0.0809***', '-0.976***', '-0.00414', '', '-0.00688', '', '-0.0316*', '', '0.121***', '-0.127***', '-0.0889', '', '', '', '', '', '', '-0.0977***', '-0.0034', '-1.31E-05', '', '', '0.126***', '0.00658', '0.0895***', '0.0482', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '8.893***', '4,746', '0.473'],
            ['', '-0.0186', '-0.0969', '-0.021', '', '-0.02', '', '-0.0172', '', '-0.0111', '-0.00594', '-0.0684', '', '', '', '', '', '', '-0.00784', '-0.00411', '-4.02E-05', '', '', '-0.0332', '-0.00544', '-0.0233', '-0.0376', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '-0.118', '', ''],
            ['Marshall Islands', '0.201***', '-1.156***', '0.0566', '0.0979***', '-0.00893', '-0.233***', '-0.130***', '0.0217', '-0.00492', '0.0928***', '-0.00874', '', '', '', '', '', '', '-0.231***', '0.0130**', '-0.000110*', '-0.159', '', '0.103', '0.0879***', '0.0707', '-0.0209', '', '', '', '', '0.052', '', '', '', '', '', '', '', '', '', '', '', '', '6.386***', '860', '0.765'],
            ['', '-0.038', '-0.163', '-0.0355', '-0.0216', '-0.0124', '-0.046', '-0.0355', '-0.0174', '-0.0308', '-0.0111', '-0.168', '', '', '', '', '', '', '-0.0185', '-0.00624', '-6.05E-05', '-0.198', '', '-0.0669', '-0.0189', '-0.0806', '-0.0601', '', '', '', '', '-0.08', '', '', '', '', '', '', '', '', '', '', '', '', '-0.226', '', ''],
            ['Myanmar', '0.0771***', '-0.538***', '-0.0131', '0.0127***', '0.0057', '0.109***', '', '', '', '0.101***', '0.0282', '', '', '', '', '', '', '-0.131***', '0.00327', '-5.95e-05*', '-0.149***', '', '-0.0859***', '0.0917***', '-0.0976**', '-0.0113', '', '', '', '', '0.0562', '0.000686', '', '', '', '', '', '', '', '', '', '', '', '11.58***', '3,647', '0.577'],
            ['', '-0.02', '-0.0953', '-0.0233', '-0.00487', '-0.0166', '-0.0237', '', '', '', '-0.00623', '-0.0281', '', '', '', '', '', '', '-0.00893', '-0.00361', '-3.37E-05', '-0.0388', '', '-0.00965', '-0.0086', '-0.0416', '-0.042', '', '', '', '', '-0.0473', '-0.0341', '', '', '', '', '', '', '', '', '', '', '', '-0.118', '', ''],
            ['Mongolia', '0.0782***', '-0.667***', '-0.0562***', '0.0381***', '-0.00206', '0.0286***', '', '', '', '0.123***', '0.165***', '', '', '', '', '', '', '-0.169***', '0.00311*', '-4.17e-05**', '0.233***', '', '-0.0510***', '', '-0.00114', '0.0324', '', '', '', '', '-0.0073', '', '', '', '', '', '', '', '', '', '', '', '', '13.14***', '11,199', '0.496'],
            ['', '-0.0134', '-0.0663', '-0.0125', '-0.00233', '-0.00358', '-0.00228', '', '', '', '-0.00283', '-0.0616', '', '', '', '', '', '', '-0.00524', '-0.00177', '-1.70E-05', '-0.0115', '', '-0.00348', '', '-0.0883', '-0.0937', '', '', '', '', '-0.0883', '', '', '', '', '', '', '', '', '', '', '', '', '-0.0497', '', ''],
            ['Nepal', '-0.0373***', '-0.0328', '0.0588***', '0.0502***', '-0.0277**', '0.0118', '-0.00445', '0.161***', '0.00117', '0.0733***', '0.0665**', '', '', '', '', '', '', '-0.0950***', '0.00731***', '-7.41e-05***', '0.0938***', '0.0123', '', '0.0744***', '', '', '', '', '', '', '', '', '', '', '0.0139', '0.0807', '0.193***', '0.0585**', '0.157**', '', '', '0.0437**', '', '10.91***', '9,111', '0.466'],
            ['', '-0.0107', '-0.0325', '-0.0158', '-0.00372', '-0.0117', '-0.0125', '-0.00476', '-0.00588', '-0.00374', '-0.00534', '-0.0329', '', '', '', '', '', '', '-0.00626', '-0.00232', '-2.26E-05', '-1.00E-02', '-0.0469', '', '-0.00495', '', '', '', '', '', '', '', '', '', '', '-0.0125', '-0.0872', '-0.0298', '-0.0231', '-0.0633', '', '', '-0.0176', '', '-0.0835', '', ''],
            ['Pakistan', '0.0688***', '-0.968***', '0.0780***', '0.0916***', '-0.00771', '-0.00111***', '-0.0166***', '', '0.00106', '0.163***', '0.0303*', '', '', '', '', '', '', '-0.119***', '-0.00275*', '5.82E-06', '-0.0930***', '', '', '', '0.104***', '', '', '', '', '', '0.0442***', '', '', '', '', '', '', '', '', '', '', '0.0568***', '', '8.473***', '39,310', '0.573'],
            ['', '-0.00825', '-0.0396', '-0.0105', '-0.00346', '-0.00783', '-0.000212', '-0.00376', '', '-0.00581', '-0.00274', '-0.0172', '', '', '', '', '', '', '-0.00374', '-0.00162', '-1.55E-05', '-0.00932', '', '', '', '-0.00898', '', '', '', '', '', '-0.0126', '', '', '', '', '', '', '', '', '', '', '-0.00628', '', '-0.0543', '', ''],
            ['Palau', '0.004', '-1.308***', '-0.052', '0.025', '-.001**', '', '-0.066', '0.021', '-0.004', '', '.454**', '', '', '', '', '', '', '0.002', '.022**', '0', '-.126***', '', '-0.047', '0.003', '0***', '', '', '', '', '', '.799***', '', '', '', '', '', '', '', '', '', '', '', '.103***', '7.189***', '17,614', '0.205'],
            ['', '-0.035', '-0.218', '-0.048', '-0.031', '-0.021', '', '-0.025', '-0.011', '-0.025', '', '-0.19', '', '', '', '', '', '', '-0.007', '-0.011', '0', '-0.049', '', '-0.055', '-0.013', '0', '', '', '', '', '', '0.087', '', '', '', '', '', '', '', '', '', '', '', '-0.014', '-0.345', '', ''],
            ['Philippines', '0.0565***', '-0.767***', '0.164***', '0.0331***', '-0.0356***', '0.138***', '', '', '', '', '0.0144', '', '', '', '', '', '', '-0.100***', '0.0105***', '-8.10e-05***', '-0.212***', '', '', '0.148***', '0.0561', '', '', '', '0.162***', '', '-0.103**', '-0.0257*', '0.142***', '', '', '', '', '', '', '', '', '', '6.17e-06***', '8.628***', '24,238', '0.601'],
            ['', '-0.00613', '-0.0379', '-0.0158', '-0.000874', '-0.0134', '-0.00928', '', '', '', '', '-0.0101', '', '', '', '', '', '', '-0.00335', '-0.00177', '-1.88E-05', '-0.00861', '', '', '-0.00459', '-0.0493', '', '', '', '-0.0492', '', '-0.049', '-0.015', '-0.0498', '', '', '', '', '', '', '', '', '', '-1.84E-06', '-0.0475', '', ''],
            ['Thailand', '0.220***', '-1.054***', '-0.0353***', '0.00381**', '-0.0965***', '-0.0624***', '', '', '', '0.147***', '0.0432*', '', '', '', '', '', '', '-0.202***', '-0.00810***', '3.25e-05***', '-0.117***', '', '0.0752***', '', '', '-0.110***', '', '', '', '', '0.0766***', '', '', '', '', '', '', '', '', '', '', '', '', '9.884***', '49,664', '0.62'],
            ['', '-0.00944', '-0.0324', '-0.00486', '-0.00166', '-0.00556', '-0.00384', '', '', '', '-0.00143', '-0.0251', '', '', '', '', '', '', '-0.00309', '-0.000968', '-8.92E-06', '-0.005', '', '-0.00284', '', '', '-0.00563', '', '', '', '', '-0.00725', '', '', '', '', '', '', '', '', '', '', '', '', '-0.0316', '', ''],
            ['Tonga', '0.0631***', '-0.944***', '0.041', '', '-0.0186', '', '', '', '', '', '', '', '', '', '', '', '', '-0.108***', '0.0158***', '-0.000142***', '-0.141***', '', '', '', '-0.169**', '0.104***', '', '', '', '', '-0.00324', '', '', '', '', '', '', '', '', '', '', '', '', '7.536***', '2,130', '0.347'],
            ['', '-0.0235', '-0.145', '-0.0381', '', '-0.0168', '', '', '', '', '', '', '', '', '', '', '', '', '-0.0107', '-0.00509', '-4.21E-05', '-0.0305', '', '', '', '-0.0752', '-0.039', '', '', '', '', '-0.0689', '', '', '', '', '', '', '', '', '', '', '', '', '-0.155', '', ''],
            ['Türkiye', '0.126***', '-1.243***', '-0.0400**', '0.100***', '0.0366***', '', '', '', '', '0.0945***', '', '', '', '', '', '', '', '-0.182***', '0.0134***', '-0.000123***', '', '', '0.0193***', '0.0677***', '0.166***', '0.202***', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '6.911***', '11,521', '0.548'],
            ['', '-0.0179', '-0.0813', '-0.0176', '-0.00403', '-0.0111', '', '', '', '', '-0.00434', '', '', '', '', '', '', '', '-0.00717', '-0.00247', '-2.31E-05', '', '', '-0.00331', '-0.00783', '-0.0158', '-0.0185', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '-0.0742', '', ''],
            ['Uzbekistan', '0.0831***', '-0.680***', '0.0238', '0.0173**', '-0.0443**', '-0.0408', '', '', '', '0.160***', '-0.00668', '', '', '', '', '', '', '-0.101***', '0.00273', '5.64E-06', '0.129***', '', '0.000567', '', '-0.0997**', '-0.0952*', '', '', '', '', '0.153***', '', '', '', '', '', '', '', '', '', '', '', '', '12.83***', '4,012', '0.281'],
            ['', '-0.0269', '-0.139', '-0.0418', '-0.00782', '-0.0221', '-0.0333', '', '', '', '-0.00736', '-0.0781', '', '', '', '', '', '', '-0.0103', '-0.00537', '-4.79E-05', '-0.0278', '', '-0.00155', '', '-0.044', '-0.0518', '', '', '', '', '-0.0447', '', '', '', '', '', '', '', '', '', '', '', '', '-0.167', '', ''],
            ['Vanuatu', '0.089***', '-.831***', '-0.024', '.002**', '0.004', '-.018***', '-.069***', '', '', '.148***', '-0.024', '', '', '', '', '', '', '-.119***', '.009*', '0***', '0', '', '.041***', '.029***', '.143***', '.13***', '', '', '', '', '-0.009', '', '', '', '', '', '', '', '', '', '', '', '.148***', '10.63***', '20,722', '0.527'],
            ['', '-0.018', '-0.089', '-0.018', '-0.001', '-0.005', '-0.003', '-0.02', '', '', '-0.006', '-0.056', '', '', '', '', '', '', '-0.008', '-0.003', '0.00E+00', '', '', '-0.014', '-0.008', '-0.032', '-0.033', '', '', '', '', '-0.029', '', '', '', '', '', '', '', '', '', '', '', '-0.006', '-0.097', '', ''],
            ['Viet Nam', '0.146***', '-0.755***', '0.0504***', '0.0186***', '0.0403***', '-0.0270***', '0.0532***', '0.0185', '-0.0266', '', '-0.00366', '', '', '', '', '', '', '-0.190***', '0.00645***', '-6.15e-05***', '-0.140***', '', '', '', '-0.0101', '', '', '', '-0.105***', '', '-0.0105', '-0.0279', '0.0363***', '', '', '', '', '', '', '', '', '0.163***', '0.261***', '4.947***', '9,347', '0.701'],
            ['', '-0.0158', '-0.0671', '-0.0115', '-0.00145', '-0.00998', '-0.00214', '-0.0186', '-0.0172', '-0.0272', '', '-0.018', '', '', '', '', '', '', '-0.00538', '-0.00219', '-1.96E-05', '-0.0114', '', '', '', '-0.0106', '', '', '', '-0.0125', '', '-0.0193', '-0.0202', '-0.0127', '', '', '', '', '', '', '', '', '-0.00963', '-0.00513', '-0.0826', '', '']
          ],
          allowSearch: true
        };
      }

      this.dataObj = { ...dataObj };
      this.dataObjectStr = JSON.stringify(this.dataObj);
    }
  }
};
</script>
